
import {
  DashboardFilled,
  FileTextOutlined,
  TeamOutlined,
  ScheduleOutlined,
  AppstoreAddOutlined
} from "@ant-design/icons";
import {
  MdAdminPanelSettings
} from "react-icons/md";
import {
  GiNotebook
} from "react-icons/gi";
import { icons } from "antd/es/image/PreviewGroup";


export const menuList = [
  {
    key: "general",
    label: "General",
  },
  {
    key: "dashboard",
    label: "Dashboard",
    pathname: "/employee-dashboard",
    // children: [],
    icon: <DashboardFilled />,
  },
    {
    key: "masters",
    label: "Masters",
    pathname: "",
    children: [
      {
        key: "department",
        label: "Department",
        pathname: "/department",
      },
      {
        key: "designation",
        label: "Designation",
        pathname: "/designation",
      },
      {
        key: "role",
        label: "Role",
        pathname: "/role",
      },
        {
        key: "location",
        label: "Location",
        pathname: "/location",
      }, 
        {
        key: "loginshift",
        label: "Login Shift",
        pathname: "/login-shift",
      },
          {
        key: "lopsettings",
        label: "Lop Settings",
        pathname: "/lop-settings",
      },
      {
        key: "holiday",
        label: "Holiday",
        pathname: "/holiday",
      },
    ],
    icon: <AppstoreAddOutlined size={18} />,
  },
  {
    key: "ManageEmployee",
    label: "Employee Management",
    pathname: "/employee-management",
    // children: [],
    icon: <TeamOutlined size={18} />,
  },
  
  {
    key: "attendence",
    label: "Attendence",
    pathname: "/attendance",
    // children: [],
    icon: <MdAdminPanelSettings size={18} />,
  },
 
  {
    key:"projectMenu",
    label:"Project Menu",
    pathname:"",
    children:[{
      key:"project",
      label:"Projects",
      pathname:"/project"
    },
  {
    key:"phase",
    label:"Phase",
    pathname:"/phase"
  }],
    icon:<ScheduleOutlined/>
  },

  {
    key: "leaveAndPermissions",
    label: "Leave & Permissions",
    pathname: "",
    children: [
      {
        key: "leave",
        label: "Leave Details",
        pathname: "/leave-details",
      },
      {
        key: "permission",
        label: "Permission",
        pathname: "/permission",
      },
      {
        key: "lop",
        label: "LOP",
        pathname: "/lop",
      },
       
    ],
    icon: <GiNotebook size={18} />,
  },
  {
    key: "reports",
    label: "Reports",
    pathname: "",
    children: [
      {
        key: "employeeLeaveRecord",
        label: "Employee Leave Record",
        pathname: "/employee-leave-record",
      },
      {
        key: "employeeList",
        label: "Employee List",
        pathname: "/employee-list",
      },
       {
        key: "attendanceDetails",
        label: "Attendance Details",
        pathname: "/attendance-detail",
      },
      {
        key:"projectlist",
        label:"Project list",
        pathname:"/project-list"
      }
    ],
    icon: <FileTextOutlined />,
  },
];

 